<template>
  <Alert theme="primary" class="draft-alert" iconPlacement="left" :icon="['fas', 'info-circle']">
    <div class="draft-alert__content" v-html="content || $t('workingWithDraft')" />
  </Alert>
</template>

<script>
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  props: {
    content: String,
  },
  components: {
    Alert,
  },
}
</script>

<style lang="scss">
.draft-alert {
  gap: 0.4rem;
  overflow: hidden;
  font-size: 0.8rem;
  border: 1px solid var(--vue-elder-primary);
  border-radius: 30px;

  b {
    font-weight: bold;
  }

  & > * {
    padding: 0.8rem;
  }

  svg {
    margin: 0 0.4rem 0 0;
  }
}
</style>
